module.exports = __webpack_public_path__ + "static/media/2021_cadillac_ct5_ext_06_6DC79_1SD_GSK.cae366b3.png";